import React from "react";
import { LegalPage } from "./LegalPage";
import { termsAndConditions } from "@/content/legal";

export default function Terms() {
  return <LegalPage doc={termsAndConditions} testid="terms-page" />;
}
